import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { useLanguage } from '../../../contexts/LanguageContext';

const StepRoleAddress = ({ data, onNext, isFirstStep }) => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    role: data?.role || '',
    address: data?.address || '',
    suburb: data?.suburb || '',
    state: data?.state || '',
    postcode: data?.postcode || ''
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData?.role) newErrors.role = t('selectRole');
    if (!formData?.address) newErrors.address = 'Address is required';
    if (!formData?.suburb) newErrors.suburb = 'Suburb is required';
    if (!formData?.state) newErrors.state = 'State is required';
    if (!formData?.postcode) newErrors.postcode = 'Postcode is required';
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (validateForm()) {
      onNext(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-2">{t('letsGetStarted')}</h2>
        <p className="text-muted-foreground">{t('letsGetStartedDesc')}</p>
      </div>
      <div className="space-y-4">
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">
            {t('iAmA')} <span className="text-error">*</span>
          </label>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {[
              { value: 'owner', label: t('owner') },
              { value: 'agent', label: t('agent') },
              { value: 'developer', label: t('developer') }
            ]?.map((role) => (
              <button
                key={role?.value}
                type="button"
                onClick={() => setFormData({ ...formData, role: role?.value })}
                className={`p-4 rounded-lg border-2 transition-all text-left ${
                  formData?.role === role?.value
                    ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50'
                }`}
              >
                <p className="font-semibold text-foreground capitalize">{role?.label}</p>
              </button>
            ))}
          </div>
          {errors?.role && <p className="text-sm text-error">{errors?.role}</p>}
        </div>

        <Input
          label={t('propertyAddress')}
          type="text"
          placeholder="123 Main Street"
          value={formData?.address}
          onChange={(e) => setFormData({ ...formData, address: e?.target?.value })}
          error={errors?.address}
          required
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Input
            label={t('suburb')}
            type="text"
            placeholder="Sydney"
            value={formData?.suburb}
            onChange={(e) => setFormData({ ...formData, suburb: e?.target?.value })}
            error={errors?.suburb}
            required
          />

          <Select
            label={t('state')}
            value={formData?.state}
            onChange={(val) => setFormData({ ...formData, state: val })}
            error={errors?.state}
            required
            placeholder={t('selectState')}
            options={[
              { value: 'NSW', label: 'NSW' },
              { value: 'VIC', label: 'VIC' },
              { value: 'QLD', label: 'QLD' },
              { value: 'SA', label: 'SA' },
              { value: 'WA', label: 'WA' },
              { value: 'TAS', label: 'TAS' },
              { value: 'NT', label: 'NT' },
              { value: 'ACT', label: 'ACT' },
            ]}
          />

          <Input
            label={t('postcode')}
            type="text"
            placeholder="2000"
            value={formData?.postcode}
            onChange={(e) => setFormData({ ...formData, postcode: e?.target?.value })}
            error={errors?.postcode}
            required
          />
        </div>
      </div>
      <div className="flex justify-end">
        <Button type="submit" variant="default" iconName="ArrowRight" iconPosition="right">
          {t('continue')}
        </Button>
      </div>
    </form>
  );
};

export default StepRoleAddress;